import React from 'react';
import { Mail } from 'lucide-react';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen py-12 px-4" style={{ backgroundColor: '#FDFBF7' }}>
      <div className="max-w-4xl mx-auto">
        <article className="prose prose-lg max-w-none">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-primary mb-8" style={{ color: '#2C3E50' }}>
            Política de Privacidad
          </h1>

          {/* Section 1 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              1. Responsable del tratamiento
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              De conformidad con el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo (RGPD) y la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), se informa a los usuarios de este sitio web sobre el tratamiento de sus datos personales.
            </p>
            <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <p className="font-semibold text-primary mb-2" style={{ color: '#2C3E50' }}>Responsable del tratamiento:</p>
              <p className="text-secondary" style={{ color: '#5D6D7E' }}>Pier Andrea Saraco</p>
              <p className="text-secondary" style={{ color: '#5D6D7E' }}>NIE: Y5378093V</p>
              <p className="text-secondary" style={{ color: '#5D6D7E' }}>Dirección: Avenida Juan Carlos I 33, Los Cristianos, Arona, Santa Cruz de Tenerife, España</p>
              <p className="text-secondary" style={{ color: '#5D6D7E' }}>
                Correo electrónico: <a href="mailto:info@tantra-map.com" className="text-gold hover:underline" style={{ color: '#D4A574' }}>info@tantra-map.com</a>
              </p>
              <p className="text-secondary" style={{ color: '#5D6D7E' }}>
                Sitio web: <a href="https://tantra-map.com" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline" style={{ color: '#D4A574' }}>https://tantra-map.com</a>
              </p>
            </div>
          </section>

          {/* Section 2 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              2. Finalidad del tratamiento de los datos
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Los datos personales recopilados a través de la plataforma se utilizan para las siguientes finalidades:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>gestionar el registro de usuarios en la plataforma</li>
              <li>permitir la creación de perfiles profesionales dentro del directorio</li>
              <li>facilitar el contacto entre usuarios y profesionales</li>
              <li>administrar el funcionamiento técnico del sitio web</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              La plataforma funciona principalmente como <strong>directorio informativo de profesionales y escuelas relacionadas con el tantra</strong>.
            </p>
          </section>

          {/* Section 3 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              3. Datos personales recopilados
            </h2>
            
            <h3 className="font-semibold text-lg text-primary mb-3" style={{ color: '#2C3E50' }}>Usuarios registrados</h3>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>Datos obligatorios:</p>
            <ul className="list-disc pl-6 text-secondary space-y-1 mb-4" style={{ color: '#5D6D7E' }}>
              <li>nombre</li>
              <li>dirección de correo electrónico</li>
            </ul>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>Datos opcionales:</p>
            <ul className="list-disc pl-6 text-secondary space-y-1 mb-4" style={{ color: '#5D6D7E' }}>
              <li>teléfono</li>
            </ul>
            <p className="text-secondary mb-6" style={{ color: '#5D6D7E' }}>
              Estos datos se utilizan exclusivamente para la creación y gestión de la cuenta de usuario.
            </p>

            <h3 className="font-semibold text-lg text-primary mb-3" style={{ color: '#2C3E50' }}>Profesionales</h3>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              Los usuarios que deseen registrarse como profesionales deberán proporcionar información relacionada con su actividad profesional, que puede incluir:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-1 mb-6" style={{ color: '#5D6D7E' }}>
              <li>fotografía de perfil</li>
              <li>biografía profesional</li>
              <li>especialidades</li>
              <li>años de experiencia</li>
              <li>teléfono</li>
              <li>sitio web (si existe)</li>
            </ul>

            <h3 className="font-semibold text-lg text-primary mb-3" style={{ color: '#2C3E50' }}>Escuelas</h3>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>Las escuelas o centros podrán proporcionar además:</p>
            <ul className="list-disc pl-6 text-secondary space-y-1 mb-4" style={{ color: '#5D6D7E' }}>
              <li>nombre de la escuela</li>
              <li>teléfono</li>
              <li>sitio web</li>
              <li>dirección del centro</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Parte de esta información podrá ser visible públicamente dentro del directorio.
            </p>
          </section>

          {/* Section 4 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              4. Publicación de datos profesionales
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Los profesionales y escuelas que se registran en la plataforma proporcionan voluntariamente información profesional para la creación de su perfil dentro del directorio.
            </p>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              Esta información puede incluir datos de contacto tales como:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-1 mb-4" style={{ color: '#5D6D7E' }}>
              <li>nombre profesional</li>
              <li>teléfono</li>
              <li>correo electrónico</li>
              <li>sitio web</li>
              <li>dirección del centro o escuela</li>
              <li>fotografía de perfil</li>
              <li>información sobre servicios ofrecidos</li>
            </ul>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Al registrarse en la plataforma, el profesional autoriza expresamente la <strong>publicación de estos datos en el directorio público del sitio web</strong>, con el objetivo de permitir que los usuarios puedan encontrar y contactar con dichos profesionales.
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              La plataforma no se responsabiliza del uso que terceros puedan hacer de la información de contacto publicada.
            </p>
          </section>

          {/* Section 5 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              5. Base legal del tratamiento
            </h2>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              La base legal para el tratamiento de los datos personales es:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2" style={{ color: '#5D6D7E' }}>
              <li>el consentimiento del usuario al registrarse en la plataforma</li>
              <li>la ejecución del servicio solicitado por el usuario</li>
            </ul>
          </section>

          {/* Section 6 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              6. Conservación de los datos
            </h2>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Los datos personales se conservarán mientras el usuario mantenga su cuenta activa en la plataforma o hasta que solicite su eliminación.
            </p>
          </section>

          {/* Section 7 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              7. Derecho de supresión de datos
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Los usuarios tienen derecho a solicitar la eliminación de sus datos personales cuando estos ya no sean necesarios para la finalidad para la que fueron recogidos o cuando retiren su consentimiento.
            </p>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Para solicitar la eliminación de sus datos o de su cuenta, el usuario puede enviar una solicitud al correo electrónico:
            </p>
            <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 inline-block mb-4">
              <a href="mailto:info@tantra-map.com" className="flex items-center gap-2 text-gold hover:underline font-semibold" style={{ color: '#D4A574' }}>
                <Mail className="h-5 w-5" />
                info@tantra-map.com
              </a>
            </div>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El titular del sitio procederá a la eliminación de los datos personales en un plazo razonable, salvo cuando exista una obligación legal de conservarlos.
            </p>
          </section>

          {/* Section 8 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              8. Proveedores de servicios
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Para el funcionamiento técnico del sitio web se utilizan algunos servicios de terceros, que pueden tener acceso limitado a los datos necesarios para prestar sus servicios:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li><strong>Emergent</strong> (infraestructura de alojamiento)</li>
              <li><strong>Resend</strong> (servicio de envío de correos electrónicos)</li>
              <li><strong>OpenStreetMap</strong> (servicio de mapas)</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Estos proveedores tratan los datos únicamente para prestar sus servicios técnicos.
            </p>
          </section>

          {/* Section 9 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              9. Derechos de los usuarios
            </h2>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              Los usuarios tienen derecho a:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>acceder a sus datos personales</li>
              <li>solicitar la rectificación de datos incorrectos</li>
              <li>solicitar la supresión de sus datos</li>
              <li>solicitar la limitación del tratamiento</li>
              <li>oponerse al tratamiento de sus datos</li>
              <li>solicitar la portabilidad de los datos cuando proceda</li>
            </ul>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Para ejercer estos derechos pueden enviar una solicitud a:
            </p>
            <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 inline-block mb-4">
              <a href="mailto:info@tantra-map.com" className="flex items-center gap-2 text-gold hover:underline font-semibold" style={{ color: '#D4A574' }}>
                <Mail className="h-5 w-5" />
                info@tantra-map.com
              </a>
            </div>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              Asimismo, los usuarios tienen derecho a presentar una reclamación ante la autoridad de control competente:
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              <strong>Agencia Española de Protección de Datos (AEPD)</strong><br />
              <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline" style={{ color: '#D4A574' }}>
                https://www.aepd.es
              </a>
            </p>
          </section>

          {/* Section 10 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              10. Seguridad de los datos
            </h2>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El responsable del tratamiento adopta medidas técnicas y organizativas razonables para proteger los datos personales frente a accesos no autorizados, pérdida o alteración.
            </p>
          </section>

          {/* Section 11 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              11. Uso por menores
            </h2>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El uso de la plataforma está limitado exclusivamente a <strong>personas mayores de 18 años</strong>.
            </p>
          </section>

          {/* Section 12 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              12. Modificaciones de la política
            </h2>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El titular del sitio web se reserva el derecho de modificar la presente Política de Privacidad para adaptarla a cambios legislativos o al funcionamiento de la plataforma. Las modificaciones serán publicadas en esta misma página.
            </p>
          </section>

        </article>
      </div>
    </div>
  );
}
